import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import React, { useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { httpClient } from 'helpers/HttpClient.js';
import { FormatDateAndTimeToDb } from 'helpers/FormatData.js';

const URI = ApiEndpoint + 'operations/';

const AddSeguimiento = ({
  idQueja,
  idSeguimiento,
  currentDate,
  closeModal,
  setErrorMesagge,
  setShowErrorMessage,
  setIsError
}) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [date, setDate] = useState(currentDate);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onSubmit = data => {
    if (loading) return; // prevent double submit
    setLoading(true);
    if (idSeguimiento) {
      httpClient(
        'POST',
        URI + 'editseguimiento/',
        {
          in_recepcionqueja: idQueja,
          seguimientoqueja: idSeguimiento,
          date: FormatDateAndTimeToDb(date),
          ispresecencial: data.esPresencial,
          in_notas: data.notas,
          minute: date.getMinutes(),
          hour: date.getHours()
        },
        userData.token
      ).then(function (response) {
        if (!response.data.error) {
          closeModal();
          setIsError(false);
          setErrorMesagge('Seguimiento creado con exito');
          setShowErrorMessage(true);
        } else {
          setIsError(true);
          setErrorMesagge('Ha ocurrido un error al registrar el seguimiento');
          setShowErrorMessage(true);
          setLoading(false); // re-enable after done
        }
      });
    } else {
      httpClient(
        'POST',
        URI + 'addseguimiento/',
        {
          in_recepcionqueja: idQueja,
          date: FormatDateAndTimeToDb(date),
          ispresecencial: data.esPresencial,
          in_notas: data.notas,
          minute: date.getMinutes(),
          hour: date.getHours()
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
            setIsError(false);
            setErrorMesagge('Seguimiento creado con exito');
            setShowErrorMessage(true);
          } else {
            setIsError(true);
            setErrorMesagge('Ha ocurrido un error al registrar el seguimiento');
            setShowErrorMessage(true);
            setLoading(false); // re-enable after done
          }
        })
        .catch(function (error) {
          console.log(error);
          setIsError(true);
          setErrorMesagge('Ha ocurrido un error al registrar el seguimiento');
          setShowErrorMessage(true);
          setLoading(false); // re-enable after done
        })
        .finally(() => {});
    }
  };

  const filterTime = time => {
    const hour = time.getHours();
    return hour >= 8 && hour <= 20; // Solo entre 9:00 y 18:00
  };
  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Fecha Audiencias</Form.Label>
                <DatePicker
                  popperPlacement="bottom-start"
                  selected={date}
                  onChange={date => setDate(date)}
                  className="form-control"
                  placeholderText="DD-MM-YYYY HH:mm"
                  timeIntervals={5}
                  dateFormat="dd-MM-yyyy HH:mm"
                  showTimeSelect
                  fixedHeight
                  filterTime={filterTime}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.estado?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Notas</Form.Label>
                <FormControl
                  {...register('notas', { required: false })}
                  type="text"
                  defaultValue={''}
                  isInvalid={!!errors.audiencia}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.audiencia?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Es Presencial</Form.Label>
                <Form.Check
                  {...register('esPresencial')}
                  defaultChecked={false}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.esPresencial?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button
                type="submit"
                color="primary"
                size="sm"
                disabled={loading}
              >
                {loading ? 'Guardando...' : 'Guardar'}
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};
AddSeguimiento.propTypes = {
  idQueja: PropTypes.string.isRequired,
  closeModal: PropTypes.func,
  setErrorMesagge: PropTypes.func,
  setShowErrorMessage: PropTypes.func,
  setIsError: PropTypes.func,
  currentDate: PropTypes.date,
  idSeguimiento: PropTypes.number
};

export default AddSeguimiento;
